import React from 'react';
const Analytics = () => <div className="p-8"><h1 className="text-2xl font-bold">Analytics Page</h1></div>;
export default Analytics; 